export default __webpack_public_path__ + "static/media/Nitroxgallery_92.ee9294aa.webp";